import { useCallback, useEffect } from "react"
import ReactMarkdown from "react-markdown"
import { Button } from "@/components/ui/button"
import { useAutoTranslation, useModalStore } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"
import { changelogControllerMarkPostAsRead } from "@/shared/api/generated"
import type { ChangelogMyPostDtoRes } from "@/shared/api/generated"
import { Modal } from "@/shared/types"
import modalStyles from "../modals.module.scss"
import styles from "./styles.module.scss"

export const ChangelogModal = ({
  changelog,
}: {
  changelog: ChangelogMyPostDtoRes
}) => {
  const { t } = useAutoTranslation()
  const handleClose = useCallback(() => {
    useModalStore.getState().closeModal(Modal.CHANGELOG)
    void changelogControllerMarkPostAsRead({ postId: String(changelog.id) })
  }, [changelog.id])

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") handleClose()
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [handleClose])

  return (
    <div className={modalStyles.backdrop} onClick={handleClose}>
      <div
        className={`${modalStyles.modalCard} ${styles.card}`}
        onClick={event => event.stopPropagation()}
      >
        <div className={styles.content}>
          <ReactMarkdown>{changelog.content}</ReactMarkdown>
        </div>
        <Button className={styles.button} onClick={handleClose}>
          {t(DISCOVERED_TRANSLATION_KEYS.OK)}
        </Button>
      </div>
    </div>
  )
}
